/**
 * Reputation surface icons. `RepSparkIcon` anchors every reputation
 * surface — pill, popover, public display, points page hero.
 */

type IconProps = {
  className?: string;
};

export function RepSparkIcon({ className }: IconProps) {
  return (
    <span className={className} aria-hidden="true" role="img">
      💎
    </span>
  );
}

export function ArrowRightIcon({ className }: IconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}
